import { createFeatureSelector, createSelector, ActionReducerMap, ActionReducer, MetaReducer, Store } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Params } from '@angular/router';
import * as fromRouter from '@ngrx/router-store';


export interface RouterStateUrl {
    url: string;
    queryParams: Params;
    params: Params;
}

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
    return localStorageSync({
          keys: Object.keys(reducers),
          rehydrate: true
    })(reducer);
}

// export const metaReducers: MetaReducer<any, any>[] = [localStorageSyncReducer];
export const metaReducers: MetaReducer<any, any>[] = [];

export interface AppState {
    routerReducer: fromRouter.RouterReducerState,
}

export const reducers: ActionReducerMap<AppState> = {
    routerReducer: fromRouter.routerReducer,
}

export const getRouterState = createFeatureSelector<fromRouter.RouterReducerState<RouterStateUrl>>('routerReducer');

export class CustomSerializer implements fromRouter.RouterStateSerializer<RouterStateUrl> {
    serialize(routerState: RouterStateSnapshot): RouterStateUrl {
        const {url} = routerState;
        const {queryParams} = routerState.root;

        let state: ActivatedRouteSnapshot = routerState.root;
        while ( state.firstChild ) {
            state = state.firstChild;
        }
        const {params} = state;

        return {
            url,
            queryParams,
            params
        };
    }
}
